<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <div>
    <v-menu bottom right transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn class="mr-4" dark small color="purple darken-1" v-on="on">
          <v-icon left>link</v-icon>Share
        </v-btn>
      </template>

      <v-list dark color="#181745" width="220">
        <social-sharing
          url="https://knowledge.uneca.org/covid19/countrydata"
          title="COVID-19 Awareness available for Africa."
          description="Get all the up-to-date information on COVID-19 for Africa in one place, with in-depth insights and analysis."
          quote="Get all the up-to-date information on COVID-19 for Africa in one place, with in-depth insights and analysis."
          hashtags="COVID19,data,Africa,Data4COVID"
          twitter-user="AwarenessCo"
          inline-template
          @open="sendGA('share')"
        >
          <div>
            <network network="whatsapp">
              <div class="pa-1 ml-3 mb-3" style="cursor: pointer;">WhatsApp</div>
            </network>
            <!-- <network network="twitter">
              <div class="pa-1 ml-3 mb-3" style="cursor: pointer;">Twitter</div>
            </network> -->
            <network network="facebook">
              <div class="pa-1 ml-3 mb-3" style="cursor: pointer;">Facebook</div>
            </network>
            <network network="linkedin">
              <div class="pa-1 ml-3 mb-3" style="cursor: pointer;">LinkedIn</div>
            </network>
          </div>
        </social-sharing>
      </v-list>
    </v-menu>
    <v-menu bottom right transition="slide-x-reverse-transition">
      <template v-slot:activator="{ on }">
        <v-btn dark icon v-on="on">
          <v-icon large>menu</v-icon>
        </v-btn>
      </template>

      <v-list dark color="#181745" width="220">
        <!-- <v-list-item @click="dialogCovid = true; sendGA('info', 'covid19');">
          <v-list-item-title>About COVID-19</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogSymptoms = true; sendGA('info', 'symptoms');">
          <v-list-item-title>Symptoms</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogPrecautions = true; sendGA('info', 'prevention');">
          <v-list-item-title>Prevention</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogTesting = true; sendGA('info', 'testing');">
          <v-list-item-title>Testing</v-list-item-title>
        </v-list-item> -->
        <!-- <v-list-item @click="dialogContacts = true; sendGA('info', 'contacts');">
          <v-list-item-title>Useful Contacts</v-list-item-title>
        </v-list-item> -->
        <v-list-item @click="dialogAdvice = true; sendGA('info', 'advice');">
          <v-list-item-title>Advice</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogMythbusters = true; sendGA('info', 'mythbusters');">
          <v-list-item-title>Mythbusters</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogAbout = true; sendGA('info', 'about');">
          <v-list-item-title>About this App</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="dialogAdvice" max-width="600" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title class="title purple darken-1 white--text">Coronavirus disease (COVID-19) advice for the public</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            <div>Stay aware of the latest information on the COVID-19 outbreak, available on the WHO website</div>
            <br>
            <a href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public" target="_blank">WHO advice for the public</a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogAdvice = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMythbusters" max-width="600" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title class="title purple darken-1 white--text">Coronavirus disease (COVID-19) advice for the public</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            <div>Stay aware of the latest information on the COVID-19 outbreak, available on the WHO website</div>
            <br>
            <a href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public/myth-busters" target="_blank">WHO Mythbusters</a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogMythbusters = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAbout" max-width="70%" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title
          class="title purple darken-1 white--text"
        >About the COVID-19 Public Awareness Dashboard</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            <br />
            The COVID-19 Public Awareness Dashboard is an integrated COVID-19 dashboard for Africa, developed for the Africa UN Knowledge Hub for COVID-19 with support from Microsoft 4Afrika. Get up-to-date
information for the entire continent in one place, with in-depth insights and analysis so you're
#SmartandAware.
            <br />
             <br />
            <br />Embed a widget with the latest Africa counts into your website:
            <br />
            <br /><code style="width: 100%;">&lt;iframe width="50%" height="260px" src="https://health.hydra.africa/widget_africa.html" frameborder="0"&gt;&lt;/iframe&gt;</code>
            <br />
            <br />
            <br />Use the web API to get the latest stats: 
            <a href="../../assets/COVID-19 Public Awareness Dashboard API Doc 1.0.pdf" target="_blank">Download the API Doc</a>
            <br />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogAbout = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHydra" max-width="70%" :fullscreen="$vuetify.breakpoint.mdAndDown">
      <v-card>
        <v-card-title
          class="title purple darken-1 white--text"
        >HYDRA COVID-19 Risk Management Platform</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            The HYDRA COVID-19 Risk Management Platform is an integrated digital platform to enhance decision making and manage the risk for your organisation.
            <br />
            <br />
            <img src="../../../public/assets/slide1.png" style="height: 200px;max-width: 100%;" class="mr-3">
            <img src="../../../public/assets/symptom.png" style="height: 200px;max-width: 100%;" class="mr-3">
            <img src="../../../public/assets/slide5.png" style="height: 200px;max-width: 100%;">
            
            <br />
            <br />DIGITISED SYMPTOM TRACKING
            <br />▪ AI powered insights from periodic symptom tracking.
            <br />▪ Real time risk level awareness from screenings of employees and visitors.

            <br />
            <br />WORKPLACE AND WORKFORCE INSIGHTS
            <br />▪ Enhance Safety and Compliance for your organisation.
           
            <br />
            <br />COVID-19 DATA AND HOTSPOT AREAS
            <br />▪ Up to date regional and provincial hotspots and location intelligence overlays.

            <br />
            <br />OUTCOMES
            <br />▪ Early warning on personnel health and operations risk.
            <br />▪ Prevent loss of income and keep your business operational.
            <br />▪ Building (Indoor) and In-field (Outdoor) location intelligence.
            <br />▪ Safety and security of  people and holistic situational awareness

            <br />
            <br />
            <a href="../../../assets/COVID-19RiskManagementAwareness.pdf" target="_blank">Read more about the platform here</a>
              
            <br />
            <br />Want to get in touch?
            <br />
            <a href="mailto:info@awarenesscompany.co.za">Contact Us</a>
            <br />
            <br />- The Awareness Company
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogHydra = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "Menu",
  components: {
  },
  data: () => ({
    dialogCovid: false,
    dialogSymptoms: false,
    dialogPrecautions: false,
    dialogTesting: false,
    dialogContacts: false,
    dialogAbout: false,
    dialogHydra: false,
    dialogAdvice: false,
    dialogMythbusters: false,
    surveyCovid: false,
    surveyGuid: "",
    surveyLastSubmitDate: "",
    haveSubmittedSurvey: null
  }),
  methods: {
    sendGA(event, action) {
      //post the GA
      gtag("event", event, {
        event_category: action,
        'send_to': 'UA-161523063-2'
      });
    }
  }
};
</script>
